"use client";
import { Dispatch, SetStateAction, useState, ReactNode } from "react";
import Tooltip, { TooltipProps } from "@/components/Tooltip";
import { ActionIcon } from "@mantine/core";
import { InfoIcon } from "@/components/TooltipIcon/InfoIcon";

export interface TooltipIconProps {
  label: ReactNode;
  size?: number;
  iconSize?: number;
  className?: string;
  tooltipProps?: Omit<TooltipProps, "children" | "label">;
  setOpened?: Dispatch<SetStateAction<boolean>>;
  opened?: boolean;
}

const TooltipIcon = ({ label, opened, setOpened, size = 24, iconSize = 20, className, tooltipProps }: TooltipIconProps) => {
  const [timeoutIndex, setTimeoutIndex] = useState<undefined | NodeJS.Timeout>(undefined);
  return (
    <div
      className={className}
      onMouseEnter={() => {
        if (setOpened) {
          clearTimeout(timeoutIndex);
          setOpened(true);
        }
      }}
      onMouseLeave={() => {
        if (setOpened) {
          setTimeoutIndex(setTimeout(() => setOpened(false), 300));
        }
      }}>
      <Tooltip
        label={label}
        {...tooltipProps}
        opened={opened}
        arrowPosition="center"
        events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="white" aria-label="info" size={size}>
          <InfoIcon size={iconSize} />
        </ActionIcon>
      </Tooltip>
    </div>
  );
};

export default TooltipIcon;
